import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { useLocation, useNavigationType } from "react-router-dom";

let lenisInstance = null;
export const scrollKey = (p) => `vsl_scroll:${p}`;

export const SmoothScroll = ({ children }) => {
  const { pathname } = useLocation();
  const navType = useNavigationType(); // "POP" | "PUSH" | "REPLACE"

  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 0.9,
    });
    lenisInstance = lenis;
    if (typeof window !== "undefined") window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  useEffect(() => {
    // Only the homepage restores its own scroll (on browser back/forward).
    // Every other page — and any forward navigation — opens at the top.
    const isHomeBack = pathname === "/" && navType === "POP";
    if (!isHomeBack) {
      if (lenisInstance) { lenisInstance.resize(); lenisInstance.scrollTo(0, { immediate: true }); }
      window.scrollTo(0, 0);
    }
  }, [pathname, navType]);

  return children;
};
